/**
 * Charger connectivity derived from the last frame received (ADR-0020).
 * - ONLINE: a frame arrived within the offline timeout.
 * - OFFLINE: no frame within the timeout while the platform was measuring.
 * - UNKNOWN: the platform cannot measure right now (Redis or ingestion unavailable,
 *   or recording disabled), so silence says nothing about the charger.
 */
export const ConnectivityStatus = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  UNKNOWN: 'UNKNOWN',
} as const;

export type ConnectivityStatus =
  (typeof ConnectivityStatus)[keyof typeof ConnectivityStatus];
